import React from 'react';
import { styled } from 'baseui';
import { Block } from 'baseui/block';
import { ToolBar } from '../../../image/toolbar.react';
const ActionsContainer = styled<typeof Block, {}>(Block, ({
  $theme
}) => ({
  opacity: '0.75',
  margin: $theme.sizing.scale100,
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  right: 0,
  backgroundColor: $theme.colors.backgroundPrimary
}));
type Props = {
  onClick: (a: string) => void;
  expanded: boolean;
  showOcr?: boolean;
  downloadFile?: boolean;
};
export function ControlPanel({
  onClick,
  expanded,
  showOcr,
  downloadFile
}: Props) {
  const iconList = [{
    type: 'zoomIn',
    tooltip: 'Zoom In'
  }, {
    type: 'zoomOut',
    tooltip: 'Zoom Out'
  }, {
    type: 'fullscreen',
    tooltip: 'Zoom to fit'
  }, {
    type: 'divider'
  }, {
    type: 'rotate',
    tooltip: 'Rotate'
  }, {
    type: 'divider'
  }, {
    type: expanded ? 'collapse' : 'expand'
  }, {
    type: 'divider'
  }];
  if (downloadFile === true) {
    iconList.push({
      type: 'download',
      tooltip: 'Download'
    });
  }
  if (showOcr === true) {
    iconList.push({
      type: 'show',
      tooltip: 'OCR'
    });
  }
  return <ActionsContainer>
      <ToolBar iconList={iconList} onIconClick={onClick} iconOverrides={{
      BaseButton: {
        style: ({
          $theme
        }) => {
          return {
            width: '20px',
            height: '20px',
            margin: 0,
            color: $theme.colors.primary,
            padding: '2px'
          };
        }
      }
    }} />
    </ActionsContainer>;
}